import { render, staticRenderFns } from "./SubscriptionPlanCard.vue?vue&type=template&id=51b9c72c&"
import script from "./SubscriptionPlanCard.vue?vue&type=script&lang=js&"
export * from "./SubscriptionPlanCard.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionPlanCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports